/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationconversationdirect2Inputs */

const en_moderationconversationdirect2 = /** @type {(inputs: Moderationconversationdirect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct chat`)
};

const de_moderationconversationdirect2 = /** @type {(inputs: Moderationconversationdirect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktnachricht`)
};

/**
* | output |
* | --- |
* | "Direct chat" |
*
* @param {Moderationconversationdirect2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationconversationdirect2 = /** @type {((inputs?: Moderationconversationdirect2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationconversationdirect2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationconversationdirect2(inputs)
	return de_moderationconversationdirect2(inputs)
});
export { moderationconversationdirect2 as "moderationConversationDirect" }